module.exports = __webpack_public_path__ + "img/flagIcon-1.1d5ba506.png";